import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=40c6d1fc&scoped=true"
import script from "./LiveDetail.vue?vue&type=script&lang=js"
export * from "./LiveDetail.vue?vue&type=script&lang=js"
import style0 from "./LiveDetail.vue?vue&type=style&index=0&id=40c6d1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c6d1fc",
  null
  
)

export default component.exports